module.exports = __webpack_public_path__ + "img/defecto.4dee3ca2.svg";